module.exports = __webpack_public_path__ + "assets/img/btn-download-google-play-fceb2c77.png";